<template>
  <div class="imgHeader">
    <img :src="imgUrl" alt="" />
  </div>
</template>

<script>
  export default {
    name: 'ImgHeader',
    props: {
      imgUrl: {
        type: String,
        required: true,
      },
    },
    data() {
      return {}
    },
    mounted() {},
    methods: {},
  }
</script>

<style></style>
